import { createActionThunk } from 'redux-thunk-actions'

import api from 'core/api'

const getType = type => `@users/sessions/prolong/${type}`

export const prolong = createActionThunk(
  getType('PROLONG'),
  api('/users/sessions/prolong', { method: 'PUT' })
)

let interval_id

export const setupSessionProlongation = props => dispatch => {
  clearInterval(interval_id)
  interval_id = setInterval(() => dispatch(prolong()), 60 * 1000)
}

export const destroySessionProlongation = props => dispatch => {
  clearInterval(interval_id)
}



// WEBPACK FOOTER //
// ./src/modules/users/sessions/prolong.js